import React from "react";
// import { useHistory } from "react-router-dom";
import Card from "react-credit-cards";

import {
  formatCreditCardNumber,
  formatCVC,
  formatExpirationDate,
} from "./utils";
import styles from "./styles.css";

import "react-credit-cards/es/styles-compiled.css";

export default class App extends React.Component {
    routeChange=()=> {
        let path = `/`;
        // let history = useHistory();
        this.props.history.push(path);
      }
  render() {
  
    return (
      <div   >
      <h1><br />
        getCredit  <br />
        </h1>
        <div className="App-payment">
           
          <Card
            number="4321********1234"
            name="Johnny John"
            expiry="3099"
            cvc="123"
            focused="number"
           
          />
         
        <h1><br />
    
        הדרכת שימוש<br /></h1>
<h3 dir="rtl">השימוש ב getCredit  הוא פשוט ביותר<br />
כל מה שנדרש זה להפנות את הגולש לדף הגביה<br />
על מנת לבנות את הקישור בצורה נכונה נדרש להכין שני דברים מראש:<br />
דרוש התחברות ל dugoly.com  , נזדקק ל dugoly_uid<br />
כמו כן יש לשמור את לוגו החברה ב מערכת של easydone , נזדקק ל logo_id<br />
שני דברים אלו ניתן לבצע דרך הקישור הבא: https://getcredit.link/uploader<br />
לאחר שתעלה את הלוגו תקבל קישור לתמונת הלוגו, מקישור זה נוכל להוציא הן את ה dugoly_uid והן את ה logo_id<br />
דוגמה לקישור ללוגו:<br />
<br />
http://www.easydone.online/uploads/-MO0rfu7iS6SO7iFQS2x/ce82985b-09ac-4fcd-a548-1c2410ffeb28.png<br />
<br />
הפרמטר האחרון הוא ה logo_id (יש לכלול את הסיומת)<br />
והפרמטר שלפניו הוא ה dugoly_uid<br />
במקרה זה:<br />
<br />
הdugoly_uid  שלך הוא:  -MO0rfu7iS6SO7iFQS2x<br />
<br />
ה logo_id שלך הוא: ce82985b-09ac-4fcd-a548-1c2410ffeb28.png<br />
<br />
עכשיו נבנה את הקישור<br />
<br />
על מנת להפנות גולשים לדף הזנת פרטי אשראי עליך לבנות את הקישור באופן הבא:<br />
<br />
https://getcredit.link/get-credit-card-details/[dugoly_uid]/[client_id]/[amount]/[business_name]/[logo_id]<br />
<br />
<br />
ה business_name זהו שם העסק כפי שאתה רוצה שיופיע בדף הגביה<br />
את client_id אתה מזין איזה קוד כרצונך, המשמעות של קוד זה היא הזיהוי של הלקוח, ע"מ שתוכל לזהות מי הלקוח שהזין את פרטי כרטיס האשראי <br />
וכן amount זהו סכום העסקה<br />
ב 3 הפרמטרים האלו (business_name, client_id, amount) אתה יכול להזין איזה נתונים שאתה רוצה, אבל אין להשאיר אותם ריקים<br />
<br />
דוגמה לקישור מלא:<br />
https://getcredit.link/get-credit-card-details/-MO0rfu7iS6SO7iFQS2x/client/440$/motto,%20Application%20and%20website%20development/4a0a8bc9-aea3-4e7f-9e40-43bc2831ee98.png<br />
<br />
בזה גמרנו את מה שנדרש לעשות, עכשיו רק תבנה קישור מהאתר שלך לפי הקישור שבנינו,  והמשתמש יופנה לדף הגביה<br />
ומה יקרה אח"כ?<br />
לאחר שהמשתמש ימלא את הפרטים תוצג לו הודעת "תודה" ולאחר מכאן הוא יופנה בחזרה לאתר שלך כלומר לדף שממנו הוא הגיע, <br />
לאותו URL שממנו הוא הופנה לתשלום, אבל בתוספת פרמטר-שאילתה ?received=true<br />
<br />
הערה: אם document.referrer לא עובד (תלוי בצורת ההפניה) הוא יוחזר לדף המפנה אבל ללא השאילתה<br />
את המשך תהליך השרות, אתה עושה באתר שלך<br /><br />
<b>איך אתה מקבל את פרטי האשראי של הלקוחות שלי? </b><br /><br />
כשלקוח שממלא הזמנה עבורך, פרטי האשראי שלו מועברים בצורה מאובטחת ונשמרים במאגרי המידע שלנו, תחת זיהוי המשתמש שלך.<br />
ואתה מקבל הודעה על ההזמנה לאימייל שלך (לפי האימייל ששמור במערכת הזיהוי של dugoly)<br />
בהודעה אתה מקבל את פרטי הזיהוי של העסקה:<br />
את קוד הזיהוי של הלקוח (Customer ID)<br />
ואת קוד הזיהוי של העסקה (Transaction ID)<br /><br />
אתה יכול להכנס לכתובת זו:<br />
<a href="https://getcredit.link/details-receiver" >https://getcredit.link/details-receiver</a><br />
תצטרך להזדהות במערכת הזיהוי של dugoly(הכפתור נמצא בראש העמוד), ולהזין את זיהוי הלקוח ואת זיהוי העסקה.<br />
לאחר מכאן תקבל את פרטי האשראי.<br />
שים לב, הלקוח סומך עליך, שתבצע את העסקה כפי שסוכם עימו, בדיוק.<br />
אנא הקפד על כך!<br />
כמו כן יש לשמור את פרטי האשראי בצורה מאובטחת<br />
האחריות עליך!<br />



</h3>
<button className="btn btn-primary btn-block" onClick={()=>{ this.props.history.push('/');}}>back to home</button>

        
         
        </div>
      </div>
    );
  }
}





// WEBPACK FOOTER //
// ./src/User_manual_he.js